module.exports = __webpack_public_path__ + "img/reisen udongein inaba_sc1.b13c764d.png";